import React from "react";
import { Popover } from "antd";

export const coloresEstado: Record<string, string> = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
};

export function formatFechaNacimiento(fecha: any): string {
  if (!fecha) return "—";
  if (typeof fecha === "string") return fecha.split("T")[0];
  if (fecha.format) return fecha.format("YYYY-MM-DD");
  return String(fecha).split("T")[0];
}

export function getTipoParticipante(tipo: string | undefined): string | null {
  if (tipo === "1") return "Persona Natural";
  if (tipo === "2") return "Persona Juridica";
  if (tipo === "3") return "Grupo Conformado";
  return null;
}

export function getEstadoDocumento(datos: any): React.ReactNode {
  if (datos?.checkaceptar) return <span style={{ color: coloresEstado["Aceptado"] }}>Aceptado</span>;
  if (datos?.checkcancelar) return <span style={{ color: coloresEstado["Rechazado"] }}>Rechazado</span>;
  if (datos?.checksubsanable) return <span style={{ color: coloresEstado["Subsanar"] }}>Subsanar</span>;
  if (datos?.checksubsanado) return <span style={{ color: coloresEstado["Subsanado"] }}>Subsanado</span>;
  return <span style={{ color: coloresEstado["Sin Revisar"] }}>Sin Revisar</span>;
}

export function renderUrlParticipante(datos: any): React.ReactNode {
  if (!datos || !("url_participante" in datos)) {
    return <span style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}>No se cargo un documento</span>;
  }
  if (datos.url_participante.length > 27) {
    return (
      <Popover content={datos.url_participante} title="Nombre del documento">
        <span style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}>
          {`${datos.url_participante.substring(0, 24)}...`}
        </span>
      </Popover>
    );
  }
  return <span style={{ fontFamily: "Montserrat-Regular", cursor: "pointer" }}>{`${datos.url_participante}`}</span>;
}
